import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";

/** Google フォーム等（https）または mailto: を開く */
export async function openPartnerContactUrl(url: string): Promise<void> {
  const trimmed = url.trim();
  if (!trimmed) return;
  const lower = trimmed.toLowerCase();
  if (lower.startsWith("mailto:")) {
    if (Capacitor.isNativePlatform()) {
      try {
        await Browser.open({ url: trimmed });
      } catch {
        window.location.href = trimmed;
      }
      return;
    }
    window.location.href = trimmed;
    return;
  }
  await openHttpsUrl(trimmed);
}

/** Capacitor WebView でも確実に開くための https オープン */
export async function openHttpsUrl(url: string): Promise<void> {
  const openTab = () => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  if (Capacitor.isNativePlatform()) {
    await Browser.open({ url }).catch(() => {
      openTab();
    });
    return;
  }
  openTab();
}
